import React from 'react';
import {
  Plane, MapPin, Calendar, Users, Sparkles, TrendingUp,
  ChevronRight, Shield, Clock, Train, Hotel, CheckCircle, Bell
} from 'lucide-react';
import '../HeroDashboard.css';

const HeroDashboardPreview = () => {
  return (
    <div className="hdp-wrap" aria-hidden="true">
      {/* Floating micro-badges */}
      <div className="hdp-badge hdp-badge-1">
        <MapPin size={11} />
        <span>3 Trips</span>
      </div>
      <div className="hdp-badge hdp-badge-2">
        <TrendingUp size={11} />
        <span>92% Match</span>
      </div>
      <div className="hdp-badge hdp-badge-3">
        <Sparkles size={10} />
      </div>

      {/* Main dashboard frame */}
      <div className="hdp-board">

        {/* ═══ ZONE 1: Status Bar ═══ */}
        <div className="hdp-status">
          <div className="hdp-profile">
            <div className="hdp-avatar">A</div>
            <div className="hdp-profile-info">
              <span className="hdp-greet">Good morning</span>
              <span className="hdp-uname">Alok Yadav</span>
            </div>
          </div>
          <div className="hdp-status-pills">
            <div className="hdp-pill hdp-pill-trip">
              <MapPin size={10} />
              <span>Jaipur, Rajasthan</span>
              <span className="hdp-live-dot"></span>
            </div>
            <div className="hdp-pill hdp-pill-date">
              <Calendar size={10} />
              <span>28 Apr – 5 May</span>
            </div>
          </div>
          <div className="hdp-kpi-row">
            <div className="hdp-kpi"><span className="hdp-kpi-val">3</span><span className="hdp-kpi-lbl">Trips</span></div>
            <div className="hdp-kpi"><span className="hdp-kpi-val">7</span><span className="hdp-kpi-lbl">Buddies</span></div>
            <div className="hdp-kpi hdp-kpi-accent"><span className="hdp-kpi-val">92%</span><span className="hdp-kpi-lbl">Match</span></div>
          </div>
        </div>

        {/* ═══ ZONE 2: AI Planner Focus Panel ═══ */}
        <div className="hdp-planner">
          <div className="hdp-planner-head">
            <div className="hdp-planner-title-row">
              <Sparkles size={14} className="hdp-planner-icon" />
              <span className="hdp-planner-title">AI Planner</span>
              <span className="hdp-confidence-tag">
                <Shield size={9} />
                High Fit
              </span>
            </div>
            <span className="hdp-planner-regen">
              <Clock size={9} />
              Regenerated 2m ago
            </span>
          </div>
          <p className="hdp-planner-summary">
            7-day cultural + food route optimized for weather and budget
          </p>
          {/* Route visualization */}
          <div className="hdp-route">
            <div className="hdp-route-stop hdp-route-active">
              <div className="hdp-route-dot"></div>
              <span>Delhi</span>
            </div>
            <div className="hdp-route-line"></div>
            <div className="hdp-route-stop">
              <div className="hdp-route-dot"></div>
              <span>Jaipur</span>
            </div>
            <div className="hdp-route-line"></div>
            <div className="hdp-route-stop">
              <div className="hdp-route-dot"></div>
              <span>Udaipur</span>
            </div>
          </div>
          <button className="hdp-plan-cta">
            View Plan <ChevronRight size={13} />
          </button>
        </div>

        {/* ═══ ZONE 3: Smart Insights 2×2 Grid ═══ */}
        <div className="hdp-insights">
          {/* Trip Readiness */}
          <div className="hdp-icard">
            <div className="hdp-icard-head">
              <CheckCircle size={11} className="hdp-ic-icon" />
              <span>Trip Readiness</span>
            </div>
            <div className="hdp-icard-body hdp-budget-body">
              <svg viewBox="0 0 48 48" className="hdp-ring">
                <circle cx="24" cy="24" r="18" fill="none" stroke="rgba(26,143,152,0.1)" strokeWidth="4.5" />
                <circle cx="24" cy="24" r="18" fill="none" stroke="url(#rG)" strokeWidth="4.5"
                  strokeDasharray="110" strokeDashoffset="11" strokeLinecap="round"
                  style={{transform:'rotate(-90deg)',transformOrigin:'50% 50%'}} />
                <defs>
                  <linearGradient id="rG" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#1A8F98" />
                    <stop offset="100%" stopColor="#88E1E5" />
                  </linearGradient>
                </defs>
              </svg>
              <div className="hdp-budget-txt">
                <span className="hdp-b-val">89%</span>
                <span className="hdp-b-cap">complete</span>
              </div>
            </div>
          </div>

          {/* Calendar Sync */}
          <div className="hdp-icard">
            <div className="hdp-icard-head">
              <Calendar size={11} className="hdp-ic-icon" />
              <span>Calendar Sync</span>
            </div>
            <div className="hdp-icard-body">
              <span className="hdp-icard-big">4</span>
              <span className="hdp-icard-sub">free days detected</span>
            </div>
          </div>

          {/* Stay + Transit */}
          <div className="hdp-icard">
            <div className="hdp-icard-head">
              <Train size={11} className="hdp-ic-icon" />
              <span>Stay + Transit</span>
            </div>
            <div className="hdp-icard-body hdp-transit-body">
              <div className="hdp-transit-row">
                <Hotel size={10} />
                <span>2 hotels</span>
              </div>
              <div className="hdp-transit-row">
                <Plane size={10} />
                <span>3 options</span>
              </div>
            </div>
          </div>

          {/* Buddy Match */}
          <div className="hdp-icard">
            <div className="hdp-icard-head">
              <Users size={11} className="hdp-ic-icon" />
              <span>Buddy Match</span>
            </div>
            <div className="hdp-icard-body hdp-match-body">
              <div className="hdp-match-stack">
                <div className="hdp-m-av" style={{background:'#1A8F98'}}>A</div>
                <div className="hdp-m-av" style={{background:'#0b959c'}}>P</div>
                <div className="hdp-m-av" style={{background:'#88E1E5',color:'#0b595e'}}>V</div>
                <div className="hdp-m-av hdp-m-av-more">+2</div>
              </div>
              <span className="hdp-match-lbl">5 compatible</span>
            </div>
          </div>
        </div>

        {/* ═══ ZONE 4: Action Timeline ═══ */}
        <div className="hdp-timeline">
          <div className="hdp-tl-items">
            <div className="hdp-tl-item">
              <CheckCircle size={10} className="hdp-tl-icon hdp-tl-green" />
              <span>Visa/ID checklist complete</span>
            </div>
            <div className="hdp-tl-item">
              <Bell size={10} className="hdp-tl-icon hdp-tl-amber" />
              <span>Price drop: save ₹2,300</span>
            </div>
            <div className="hdp-tl-item">
              <Clock size={10} className="hdp-tl-icon hdp-tl-red" />
              <span>Best booking window closes in 18h</span>
            </div>
          </div>
          <svg className="hdp-tl-spark" viewBox="0 0 60 20" preserveAspectRatio="none">
            <defs>
              <linearGradient id="tlF" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="rgba(26,143,152,0.18)" />
                <stop offset="100%" stopColor="rgba(26,143,152,0)" />
              </linearGradient>
            </defs>
            <path d="M0 16 Q8 14,16 12 T32 8 T48 10 T60 4 V20 H0Z" fill="url(#tlF)" />
            <path d="M0 16 Q8 14,16 12 T32 8 T48 10 T60 4" fill="none" stroke="#1A8F98" strokeWidth="1.4" strokeLinecap="round" />
          </svg>
        </div>

      </div>
    </div>
  );
};

export default HeroDashboardPreview;
